const f = ["#ffffd1", "#aad591", "#468e54", "#1b3e18"], E = ["#ffffd1", "#c9e5a1", "#55a15c", "#377b4c", "#1b3e18"], c = [
  "#ffffd1",
  "#c9e5a1",
  "#8ac481",
  "#55a15c",
  "#377b4c",
  "#1b3e18"
];
export {
  f as DEMOGRAPHICS_YELLOW_GREEN_4,
  E as DEMOGRAPHICS_YELLOW_GREEN_5,
  c as DEMOGRAPHICS_YELLOW_GREEN_6
};
//# sourceMappingURL=index.es5689.js.map
